import { ApiError, createApiClient, type ApiErrorBody } from '@nebueye/shared'

export const api = createApiClient()

/** The viewer's IANA zone; the API buckets "today" and daily charts in it. */
export const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'

/** Session-authenticated calls outside the read-only client (devices). */
export async function apiFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`/api/v1${path}`, { credentials: 'include', ...init })
  const body = (await res.json().catch(() => null)) as (T & Partial<ApiErrorBody>) | null
  if (!res.ok) {
    throw new ApiError(res.status, body?.error?.code ?? 'internal', body?.error?.message ?? 'Something went wrong. Try again in a moment.', body?.error?.requestId)
  }
  return body as T
}
